module.exports = __webpack_public_path__ + "media/application/images/svgs/repeat-6d3fb1edcc3db6e6f457f6d90220a54b.svg";